import * as i0 from "@angular/core";
import * as i1 from "../../common/http-helpers/http.wrapper";
var PatientProxy = /** @class */ (function () {
    function PatientProxy(httpWrapper) {
        this.httpWrapper = httpWrapper;
    }
    PatientProxy.prototype.getPatientDetails = function () {
        return this.httpWrapper.get('PatientPortalPatient', 'GetPatientDetails');
    };
    PatientProxy.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PatientProxy_Factory() { return new PatientProxy(i0.ɵɵinject(i1.HttpWrapper)); }, token: PatientProxy, providedIn: "root" });
    return PatientProxy;
}());
export { PatientProxy };
